<template>
 <div>
	 <div>
		<el-input class="searchInput" @keyup.enter.native="Search" v-model="val" placeholder="文章标题、作者、关键词、摘要" size="small" ></el-input>
		<a class="search_button" @click="Search">搜索</a>
		<!-- <a @click="AdvancedSearch" href="javascript:void(0);" class="highsearch">高级检索</a> -->
		<div class="clearfix"></div>
	</div>
<div class="five quick_button">
	<span>
		<router-link to="/dlistnum">期刊索引</router-link>
	</span>
	<span>
		<router-link to="/AdvancedSearch?isdatab=true">高级检索</router-link>
	</span>
	<span>
		<router-link to="/DownloadlistViewlist?Key=ReadRank">下载排行</router-link>
	</span>
	<span>
		<router-link to="/DownloadlistViewlist?Key=ViewRank">浏览排行</router-link>
	</span>
</div>
 </div>
</template>
<script>
export default {
  name: 'search',
  data () {
    return {
		val:""
    }
  },
  methods:{
	  //简单搜索
	  Search(){
		  if(this.val ==""){
			  alert('请填写检索内容')
		  }else{
			  this.$newOpen("/#/QuickSearch?isdatab=true")
			  localStorage.setItem("value",this.val)
			  }
	  },
	  //高级搜索
	  AdvancedSearch(){
		  	this.$router.push("/AdvancedSearch?isdatab=true")
	  }
  }
}
</script>
<style>
.searchInput .el-input__inner{
	border-radius: 0px !important; 
	border: 1px #edad48 solid;
}
.searchInput .el-input__suffix{
	line-height: 35px;
	    right: -20px !important;
}
.el-input--suffix .el-input__inner{

}
.search .searchInput .el-input__inner{
	box-sizing: content-box;
		padding-right: 15px;
		margin-right:15px;
}
.search .el-input--small{
	
	padding-right: 8px;
	/* padding-right: 13px; */
}
.searchInput{ float: left; width: 75% !important;}
.search_button{
	display: inline-block;
	float: left; width: 20%;
	background:#edad48;
	height: 32px; line-height: 32px; text-align: center;
	color: #fff;
}
.quick_button span,.quick_button a{font-size: 13px; margin-right: 1%; color: #8d7325;}
@media (max-width:1200px){
	.searchInput{width: 55% !important;}
	.quick_button span,.quick_button a{ margin-right: 4%;}
}
.highsearch{ line-height:32px ; margin-left: 10px;}
</style>
